const $ = jQuery;

class DateRangePickers {
	constructor() {
		this.drp = null;
	}

	bindEvents() {
		// Initialize daterangepicker
		this.drp = $("#date-range").daterangepicker({
			autoApply: true,
			locale: {
				format: "MM/DD/YYYY",
				separator: " | ",
				fromLabel: "From",
				toLabel: "To",
			},
			startDate: moment().format("MM/DD/YYYY"),
			endDate: moment().format("MM/DD/YYYY"),
		});

		// Assign the start date and end date to their respective hidden fields when dates are chosen
		this.drp.on("apply.daterangepicker", (ev, picker) => {
			$("#form-field-start_date").val(picker.startDate.format("YYYY-MM-DD"));
			$("#form-field-end_date").val(picker.endDate.format("YYYY-MM-DD"));

			// Call the correct function based on the data-calc-type attribute
			const calcType = $("#date-range").data("calc-type");
			if (calcType === "posting") {
				cSCalculatorSubmit();
			} else if (calcType === "content") {
				cSCalculatorContentSubmit();
			}
		});
	}

	updateDateRange(startDate, endDate) {
		this.drp
			.data("daterangepicker")
			.setStartDate(moment(startDate, "YYYY-MM-DD").format("MM/DD/YYYY"));
		this.drp
			.data("daterangepicker")
			.setEndDate(moment(endDate, "YYYY-MM-DD").format("MM/DD/YYYY"));

		$("#form-field-start_date").val(startDate);
		$("#form-field-end_date").val(endDate);

		const calcType = $("#date-range").data("calc-type");
		if (calcType === "posting") {
			cSCalculatorSubmit();
		} else if (calcType === "content") {
			cSCalculatorContentSubmit();
		}
	}
}

export default DateRangePickers;
